import { settingsGuideValidate } from '../../application/dtos/settings_guide_validate'
export class settingsGuideEntity {
    constructor({owner, fees}){
        this.owner = owner;
        this.fees = fees;
    }

    isValid() {
        return settingsGuideValidate(this);
    }
}